import Flex from '@dnb/eufemia/components/flex/Flex';
import { useOutletContext } from 'react-router-dom';

import { ApiProviderPageOutletContext } from '..';
import { AccessManagementSection } from './AccessManagementSection';
import ScopeRequestSection from './ScopeRequestSection/ScopeRequestSection';
import ScopesSection from './ScopeSection/ScopesSection';
import { VisibilityManagementSection } from './VisibilityManagementSection';

export function VisibilityAndAccessManagementTab() {
  const { api } = useOutletContext<ApiProviderPageOutletContext>();

  return (
    <Flex.Stack gap="large" wrap={false}>
      <VisibilityManagementSection />
      <AccessManagementSection />
      {api.type === 'REST' && <ScopeRequestSection />}
      <ScopesSection />
    </Flex.Stack>
  );
}
